<template>
  <div>
    <!--废弃打印  -->
    <div class="main" v-for="(datas, index) in printData" :key="index" style="page-break-after:always;">
      <div class="content">
        <div class="top">
          <div class="title">废弃商品</div>
          <div>{{ datas.number }}/{{ datas.boxTotal }}</div>
        </div>
        <div class="footer">
          <div class="text">
            <p> <span> 废弃时间:</span> {{ datas.created_at }}</p>
            <p> <span> 废弃类型:</span> {{ datas.abandon }}</p>
            <p> <span> 废弃原因:</span></p>
            <div class="remark">
              {{ datas.reason }}
            </div>
            <img :src="datas.QRImgUrl" alt="" style="width: 300px;height: 300px;">
          </div>
          <div class="porder-box">
            <div class="porder">
              {{ datas.porder_sn }}
            </div>
            <div class="name"> {{ datas.porder.user.realname }}</div>
          </div>
          <div class="size">
            <div class="row">
              <div class="item">
                <div class="label">
                  Weight:
                </div>
                <div class="value">
                  <span>{{ datas.weight }}</span> kg
                </div>
              </div>
              <div class="item">
                <div class="label">
                  担当:
                </div>
                <div class="value">
                  {{ datas.porder.y_admin.realname }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="item">
                <div class="label">
                  Size:
                </div>
                <div class="value">
                  <span>{{ datas.length }}</span>x<span>{{ datas.width }}</span>x<span>{{ datas.height }}</span>
                </div>
              </div>
              <div class="item">
                <div class="label">
                  配货:
                </div>
                <div class="value">
                  {{ datas.porder.p_admin.realname }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
import { mapState } from 'vuex';
export default {

  data() {
    return {
      getDate
    };
  },
  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
      }
    ),

  },
  mounted() {


  },
  methods: {


  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #ffffff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;
  font-weight: 600 !important;

  div {
    box-sizing: border-box !important;

  }

  .content {
    width: 1061px;
    height: 1652px;
    background: #ffffff;
    border: 8px solid #000000;

    .top {

      text-align: center;
      font-size: 140px;
      line-height: 250px;
      height: 250px;
      color: #000000;
      border-bottom: 8px solid #000000;
      display: flex;

      .title {
        flex: 1.5;
        font-size: 140px;
        border-right: 8px solid #000000;
        margin: 0;
      }

      div {
        flex: 1;
      }
    }



    .footer {
      width: 100%;
      height: 1120px;

      box-sizing: border-box;



      .text {
        border-bottom: 8px solid #000000;
        padding: 60px;
        position: relative;

        img {
          position: absolute;
          right: 60px;
          top: 60px;
        }

        p {
          font-size: 40px;
          color: #000000;
          margin-bottom: 50px;
        }

        .remark {
          font-size: 35px;
          min-height: 250px;

        }

      }

      .porder-box {
        border-bottom: 8px solid #000000;
        padding: 60px;
        font-size: 40px;
        color: #000000;

        .porder {
          font-size: 55px;
          margin-bottom: 30px;
        }

      }

      .size {
        padding: 60px;
        font-size: 40px;
        color: #000000;

        .row {
          display: flex;
          margin-bottom: 50px;
          line-height: 60px;

          .item {
            flex: 1;
            display: flex;

            .label {
              margin-right: 30px;


            }

            span {
              font-weight: bold;
              font-size: 68px
            }
          }
        }
      }


    }
  }
}
</style>
